
// reactstrap components

// core components
import IndexNavbar from "components/Navbars/IndexNavbar.js";
import IndexHeader from "components/Headers/IndexHeader.js";
import DemoFooter from "components/Footers/DemoFooter.js";
import Logo from "components/Headers/Logo.js"
import LearnMore from "components/sections/LearnMore";
import Boost from "components/sections/Boost";
import PackageHeader from "components/Headers/PackageHeader";
import Info from "components/sections/Info";
import Pack from "components/sections/Pack";
import Size from "components/sections/Size";
import LearnMoreWhite from "components/sections/LearnMoreWhite";
import ProductTable from "components/sections/ProductTable";
// here you import package


// index sections

import SectionButtons from "views/index-sections/SectionButtons.js";
import SectionNavbars from "views/index-sections/SectionNavbars.js";
import SectionNavigation from "views/index-sections/SectionNavigation.js";
import SectionProgress from "views/index-sections/SectionProgress.js";
import SectionNotifications from "views/index-sections/SectionNotifications.js";
import SectionTypography from "views/index-sections/SectionTypography.js";
import SectionJavaScript from "views/index-sections/SectionJavaScript.js";
import SectionCarousel from "views/index-sections/SectionCarousel.js";
import SectionNucleoIcons from "views/index-sections/SectionNucleoIcons.js";
import SectionDark from "views/index-sections/SectionDark.js";
import SectionLogin from "views/index-sections/SectionLogin.js";
import SectionExamples from "views/index-sections/SectionExamples.js";
import SectionDownload from "views/index-sections/SectionDownload.js";
import Powerful from "components/sections/Powerful";
import InventoryHeader from "components/Headers/InventoryHeader";
import EmailModalForm from "components/sections/EmailModalForm";
import Footer from "components/sections/Footer";
import { useNavigate } from "react-router-dom";
import React, { useState, useEffect, useRef } from "react";

function Inventory() {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalShown, setModalShown] = useState(false); // Track if modal has been shown
  const navigate = useNavigate();
  const productTableRef = useRef(null);

  const SCROLL_THRESHOLD = 600; // Adjust this value based on your layout

  useEffect(() => {
    const handleScroll = () => {
      if (!modalShown && window.scrollY > SCROLL_THRESHOLD) {
        setModalOpen(true);
        setModalShown(true); // Set modal shown to true to prevent it from opening again
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [modalShown]);

  useEffect(() => {
    if (modalOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  }, [modalOpen]);

  const handleModalToggle = () => {
    setModalOpen(!modalOpen);
  };

  const handleClose = () => {
    setModalOpen(false);
    document.body.style.overflow = 'auto'; // Ensure scrolling is enabled
    navigate("/");
  };

  const handleContinue = () => {
    setModalOpen(false);
    document.body.style.overflow = 'auto'; // Ensure scrolling is enabled
  };

  return (
    <>
      <IndexNavbar />
      <InventoryHeader />
      
      <div className="main">
        <ProductTable ref={productTableRef} />
        <Footer/>
      </div>
      <EmailModalForm 
        isOpen={modalOpen} 
        handleClose={handleClose} 
        handleContinue={handleContinue} 
      />
    </>
  );
}

export default Inventory;